// extracted by mini-css-extract-plugin
module.exports = {"component":"in-page-navigation-footer_component__V3AeN","details":"in-page-navigation-footer_details__WWljv","isVisible":"in-page-navigation-footer_isVisible__6LYGN"};